import React from "react";
import { Grid, TextField, Typography } from "@material-ui/core";

function WccRow(props) {
  const {
    countryCode,
    country,
    currency,
    keyValue,
    activeTab,
    partnerServiceInitiated,
    partnerAuthenticationInitiated,
    parterUtilityInitiated,
    partnerMarketingInitiated,
    partnerMarketingLiteInitiated,
    serviceMargin,
    utilityMargin,
    authenticationMargin,
    marketingMargin,
    marketingLiteMargin,
    updateMc,
    updateMlc,
    upadteAc,
    updateUc,
    updateSc,
    aisensyAuthenticationInitiated,
    aisensyUtilityInitiated,
    aisensyServiceInitiated,
    aisensyMarketingInitiated,
    aisensyMarketingLiteInitiated,
  } = props;

  // Get the data for the active tab
  const getActiveTabData = () => {
    switch (activeTab) {
      case "mc":
        return {
          aisensyPrice: aisensyMarketingInitiated,
          partnerPrice: partnerMarketingInitiated,
          margin: marketingMargin,
          updateFn: updateMc,
        };
      case "mlc":
        return {
          aisensyPrice: aisensyMarketingLiteInitiated,
          partnerPrice: partnerMarketingLiteInitiated,
          margin: marketingLiteMargin,
          updateFn: updateMlc,
        };
      case "sc":
        return {
          aisensyPrice: aisensyServiceInitiated,
          partnerPrice: partnerServiceInitiated,
          margin: serviceMargin,
          updateFn: updateSc,
        };
      case "uc":
        return {
          aisensyPrice: aisensyUtilityInitiated,
          partnerPrice: parterUtilityInitiated,
          margin: utilityMargin,
          updateFn: updateUc,
        };
      case "ac":
        return {
          aisensyPrice: aisensyAuthenticationInitiated,
          partnerPrice: partnerAuthenticationInitiated,
          margin: authenticationMargin,
          updateFn: upadteAc,
        };
      default:
        return {
          aisensyPrice: aisensyMarketingInitiated,
          partnerPrice: partnerMarketingInitiated,
          margin: marketingMargin,
          updateFn: updateMc,
        };
    }
  };

  const { aisensyPrice, partnerPrice, margin, updateFn } = getActiveTabData();

  return (
    <React.Fragment key={`${keyValue}-${activeTab}`}>
      <Grid item xs={12} md={2} container alignItems="center">
        <Typography variant="h5">{country}</Typography>
      </Grid>

      <Grid item xs={12} md={10}>
        <Grid container spacing={2}>
          {/* AiSensy Price */}
          <Grid item xs={4}>
            <TextField
              fullWidth
              type="Number"
              variant="outlined"
              placeholder="0"
              disabled={true}
              margin="dense"
              value={aisensyPrice}
              name="aisensyPrice"
              InputProps={{
                startAdornment: currency === "USD" ? "$" : "₹",
              }}
            />
          </Grid>
          {/* Margin */}
          <Grid item xs={4}>
            <TextField
              key={`margin-${activeTab}-${countryCode}`}
              fullWidth
              type="Number"
              variant="outlined"
              placeholder="0"
              margin="dense"
              onChange={(e) => {
                const marginValue = Number(e.target.value) * 100000 ?? 0;
                const newPrice = aisensyPrice * 100000 + marginValue;
                updateFn(newPrice, countryCode, marginValue);
              }}
              defaultValue={margin}
              name="margin"
              InputProps={{
                startAdornment: currency === "USD" ? "$" : "₹",
              }}
            />
          </Grid>
          {/* Partner Price */}
          <Grid item xs={4}>
            <TextField
              fullWidth
              type="Number"
              variant="outlined"
              placeholder="0"
              disabled={true}
              margin="dense"
              name="partnerPrice"
              value={partnerPrice}
              InputProps={{
                startAdornment: currency === "USD" ? "$" : "₹",
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default React.memo(WccRow);
